module.exports = __webpack_public_path__ + "img/lazy_engine_oil.9c9a722e.png";